import BaseChannel from "../base_channel.js";
import { camelizeKeys } from "../../utils/utils.js";

class CurrentUserIdentificationChannel extends BaseChannel {

  subscribe = (onDataReceived) => {
    BaseChannel.reloadConsumer();

    const { consumer: { subscriptions } } = window;

    this.channel = subscriptions.create(this.channelName(), {
      received(data) {
        if(onDataReceived) {
          onDataReceived(camelizeKeys(data));
        }
      }
    });
  }

  channelName = () => {
    return "CurrentUserIdentificationChannel";
  }
}

export default CurrentUserIdentificationChannel;